import {PricingItem} from "./pricing-item/pricing-item";

export class CustomGroup {

    public id?: string;
    public title?: string;
    public order?: number;
    public pricingItems?: PricingItem[];
    public isDuplicated?: boolean;
    public totalAppliedPrice?: string;

    get isValid(): boolean { return this.errors.length === 0; }

    get errors(): string[] {
        const errorsList = [];
        if (this.pricingItems.length == 0) { errorsList.push('ERROR_CUSTOM_GROUP_MANDATORY_PRICING_ITEM'); }
        else if (!this.pricingItems.every(pricingItem => pricingItem.isValid)) { errorsList.push('ERROR_MANDATORY_PRICING_ITEM'); }
        if (!this.title) { errorsList.push('ERROR_CUSTOM_GROUP_MANDATORY_TITLE'); }
        if (this.isDuplicated) { errorsList.push('ERROR_CUSTOM_GROUP_DUPLICATE_TITLE'); }
        return errorsList;
    }

}
